import { getFilteredCohortAbTestKeys } from 'nove8/helpers/getFilteredCohortAbTestKeys'
import { getFirebaseKeys } from 'nove8/helpers/getFirebaseKeys'
import { mergeAbTestVariantData } from 'nove8/helpers/mergeAbTestVariantData'
import { useEffect } from 'react'
import { Countries } from 'root-constants'
import { eventLogger } from 'services/eventLogger.service'
import { useShallow } from 'zustand/shallow'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const useStartSessionEvent = (): void => {
  const {
    leadId,
    country,
    cohort,
    firebaseRemoteConfigVariantData,
    growthbookVariantData,
    isEventLoggerInitialized,
    isSessionStartEventSent,
  } = useZustandStore(
    useShallow((state) => ({
      leadId: state.lead?.id,
      country: state.lead?.country,
      cohort: state.lead?.cohort || '',
      firebaseRemoteConfigVariantData:
        state.firebaseRemoteConfigVariantData || '',
      growthbookVariantData: state.growthbookVariantData || '',
      isEventLoggerInitialized: state.isEventLoggerInitialized,
      isSessionStartEventSent: state.isSessionStartEventSent,
    })),
  )

  const { language } = useZustandSessionStore(
    useShallow((state) => ({
      language: state.language,
    })),
  )

  useEffect(() => {
    if (!isEventLoggerInitialized || isSessionStartEventSent) return

    const filteredKeys = getFilteredCohortAbTestKeys(
      cohort,
      country as Countries,
      language,
    )

    if (filteredKeys.length) {
      const mergedVariantData = mergeAbTestVariantData({
        cohort,
        firebaseRemoteConfigVariantData,
        growthbookVariantData,
      })
      const abVariant =
        filteredKeys.length === 1 ? filteredKeys[0] : filteredKeys
      const abSegmentName = getFirebaseKeys(
        cohort,
        language,
        mergedVariantData,
        country as string,
      ).split(',')

      const formattedAbSegmentName =
        abSegmentName.length > 1 ? abSegmentName : abSegmentName[0]

      eventLogger.logSessionStarted({
        cohort,
        abVariant,
        abSegmentName: formattedAbSegmentName,
      })
      useZustandStore.setState({ isSessionStartEventSent: true })
      eventLogger.logFbcSegmentActivated({
        abVariant,
        abSegmentName: formattedAbSegmentName,
      })

      return
    }

    eventLogger.logSessionStarted({ cohort })
    useZustandStore.setState({ isSessionStartEventSent: true })
  }, [
    cohort,
    firebaseRemoteConfigVariantData,
    growthbookVariantData,
    language,
    country,
    isEventLoggerInitialized,
    isSessionStartEventSent,
  ])

  useEffect(() => {
    if (leadId) {
      window.fbq('track', 'ViewContent', {}, { eventID: leadId })
    }
  }, [leadId])
}
